/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/right': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M78.94 43.81l-23-24.75h-13l18.4 19.8H24.5v9.9h36.83l-18.4 19.8h13z" _fill="#fff"/><path pid="2" _fill="#fff" d="M24.51 40.85H35.4v39.93H24.51z"/></g></g>'
  }
})
